<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/demo/inventory/list'

export default {
  name: "inventory",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>